package ui.component

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import ru.malygin.dataConverter.MainScheduleItems
import ru.malygin.dateTime.WhatDay
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.TimeDetectorItem
import ui.styles.SelectorStyle
import ui.styles.Styles
import utils.logger.log
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.px

external interface TabPanelProps:Props{
    var itemsDto: List<MainScheduleItemDto>?
    var indexDays: Int
    var timeDetectorItem: TimeDetectorItem
}
external interface CardPerItemProps:Props{
    var itemDto: MainScheduleItemDto
    var timeDetectorItem: TimeDetectorItem
}
external interface CardPerItemMultiProps:Props{
    var itemDto: List<MainScheduleItemDto>
    var timeDetectorItem: TimeDetectorItem
}
external interface ExpandTextProps:Props{
    var uniqId: String
    var maxLength: Int
    var isExpanded: Boolean
    var expandText: String
    var onClick: (newVal: Boolean) -> Unit
}
external interface MainScreenTutorGroupsSelectorProps:Props{
    var onChange: (String) -> Unit
}

class MainScreenComponents(
    val days: List<TimeDetectorItem> = WhatDay().returnWeekDay(),
    val receivedList: List<MainScheduleItemDto>?,
    val category: SelectedCategory,
    val selectedGroupForTutor: String? = null,
    val selectedGroupsListForTutor: List<String?>? = null,
) {

    /**
     * данные для всех дней
     */
    val groupedReceivedList = receivedList?.let {  keku->
        MainScheduleItems(
            dataList = keku,
            category = category
        ).returnUiGroupedItems()
    }


    /**
     * Селектор групп для кураторов
     */
    //todo ...IN PROGRESS
    val mainScreenTutorGroupsSelector = FC<MainScreenTutorGroupsSelectorProps>{ props->

        when(category){
            SelectedCategory.TUTORS -> {
                if(selectedGroupsListForTutor.isNullOrEmpty()){
//                    ReactHTML.div{//TODO todo
//                        +"+_+"
//                    }
                }else{
                    ReactHTML.select{
                        className = SelectorStyle.selectorHandler

                        this.value = selectedGroupForTutor.toString()

                        onChange = {
                            log.i(it.target.value)
                            props.onChange(it.target.value)
                        }

                        selectedGroupsListForTutor.forEach {

                            ReactHTML.option{

                                +it
                            }
                        }
                    }
                }
            }
            else -> {}
        }
    }


    /**
     * SkeletonHead - ON LOAD
     */
    val onLoadingSkeletonHead = FC<Props>{
        ReactHTML.div{

            css {
                display = Display.flex
                flexDirection = FlexDirection.row
                gap = 10.px
                marginBottom = 15.px
            }

            (1..6).forEach { _->

                ReactHTML.span{
                    className = Styles.Skeletoner.skeletoner
                    css(this.className) {
                        height = 50.px
                    }
                }
            }
        }
    }
}